<template>
	<div class="professinal-automative-tools-list">
		<div class="professinal-automative-tools-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">VVDI Series</span>
			</div>

			<div class="list">
				<p>
					VVDI series products mainly provide solutions for automotive diagnosis and electronic maintenance of over 3,000 car models worldwide. </p>

				<img :src="solution_image_01" alt="Xhorse"/>

				<p>
					VVDI series devices connected to your PC to complete the vehicle programming process via Xhorse software and support vehicle automatic diagnosis, ECU programming, parts replacement, read DTC, etc. VVDI series was designed to help you understand your car’s heart by quickly reading DTC so you can accurately determine the cause of the problem and keep your car healthy.</p>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_professional_01.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.list > p:last-child {
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 24px;
		margin-top: 44px;
	}

	.list > p:first-child {
		margin-bottom: 44px;
		font-size: 16px;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 24px;
	}

	.list > img, .list > p {
		width: 100%;
	}

	.list {
		width: 100%;
		height: 698px;
		border: none;
		margin-left: 54px;
	}

	.x-tit-con {
		font-size: 24px;
		color: #3B3A38;
		line-height: 52px;
	}

	.title {
		width: 100%;
		text-align: left;
		margin-top: 44px;
		margin-bottom: 44px;
	}

	.professinal-automative-tools-con {
		width: 70%;
		height: 930px;
		border: none;
		margin-left: 5%;
	}

	.professinal-automative-tools-list {
		width: 100%;
		height: 930px;
		border: none;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 44px;
		height: 44px;
		position: relative;
		top: 10px;
		margin-right: 10px;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-vvdi-series.vue